import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function ValDOise95Page() {
  return <DeptPage dept={departmentsData["val-d-oise-95"]} />;
}
